import AppDesktop from './app-desktop';
import AppMobile from './app-mobile';
import forDevice from '../../hoc/for-device';

export default forDevice(AppMobile, AppDesktop);



// WEBPACK FOOTER //
// ./app/components/app/app.js